<template>
  <div>
    <div v-if="typeof value === 'object'">
      <div v-if="value">
        <div v-for="(subValue, column) in value" :key="column" class="row mx-0" style="border: 1px dotted grey">
          <div :class="'col-' + (subValue !== null && typeof subValue === 'object' ? '3' : '6') + ' px-0'">
            <strong class="text-primary">{{ column }}:</strong>
          </div>
          <div :class="'col-' + (subValue !== null && typeof subValue === 'object' ? '9' : '6') + ' px-0'">
            <json-field :value="subValue"></json-field>
          </div>
        </div>
      </div>
      <div v-else class="text-muted">(leer)</div>
    </div>
    <div v-else>{{ value }}</div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: [Boolean, Number, String, Object], default: '' },
  },
  setup() {
    return {};
  },
};
</script>
